import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import BookCard from "@/components/site/BookCard";
import { useI18n } from "@/lib/i18n";
import SEO from "@/components/SEO";

const TITLES = {
    written: { bn: "লিখিত বই", en: "Written Books" },
    mcq: { bn: "MCQ বই", en: "MCQ Books" },
    "job-solution": { bn: "জব সলিউশন", en: "Job Solution" },
    ebook: { bn: "ই-বুক", en: "E-Books" },
    all: { bn: "সকল বই", en: "All Books" },
};

export default function BookList() {
    const { category } = useParams();
    const [params] = useSearchParams();
    const q = params.get("q") || "";
    const { lang } = useI18n();
    const [books, setBooks] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const url = category && category !== "all" ? `/books?category=${category}&featured=true` : "/books";
        const final = q ? `${url}${url.includes("?") ? "&" : "?"}q=${encodeURIComponent(q)}` : url;
        api.get(final).then((r) => setBooks(r.data)).catch(() => {}).finally(() => setLoading(false));
    }, [category, q]);

    const title = TITLES[category]?.[lang] || TITLES.all[lang];

    return (
        <div>
            <SEO title={title} description={`${title} - Self Preparation BD`} />
            {/* Header */}
            <section className="bg-hero-grad relative overflow-hidden">
                <span className="math-symbol text-[180px] left-[5%] top-[8%]">π</span>
                <span className="math-symbol text-[140px] right-[10%] bottom-[15%]">√</span>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative">
                    <div className="text-xs font-semibold tracking-wider text-brand-red">CATEGORY</div>
                    <h1 className="text-4xl sm:text-5xl font-bold text-brand-navy mt-2">{title}</h1>
                    {q && <div className="text-brand-navy/60 mt-2">{lang === "bn" ? "অনুসন্ধান" : "Search"}: "{q}"</div>}
                </div>
            </section>

            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                {loading ? (
                    <div className="text-center text-brand-navy/60 py-20">Loading...</div>
                ) : books.length === 0 ? (
                    <div className="text-center text-brand-navy/60 py-20" data-testid="empty-list">{lang === "bn" ? "কোন বই পাওয়া যায়নি" : "No books found"}</div>
                ) : (
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5" data-testid="book-list">
                        {books.map((b) => <BookCard key={b.id} book={b} />)}
                    </div>
                )}
            </section>
        </div>
    );
}
